import { render, staticRenderFns } from "./MessageContent.vue?vue&type=template&id=9e6f78ee&scoped=true&"
import script from "./MessageContent.vue?vue&type=script&lang=js&"
export * from "./MessageContent.vue?vue&type=script&lang=js&"
import style0 from "./MessageContent.vue?vue&type=style&index=0&id=9e6f78ee&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e6f78ee",
  null
  
)

export default component.exports